import { usePaywallHost } from '@/hooks/use-paywall-host';
import { BillingModalHost } from './billing-modal/BillingModalHost';
import { FeaturePlanChoiceModal } from './plan-choice/FeaturePlanChoiceModal';

/** One URL host for the plan choice, billing setup and every typed plan limit. */
export const UpgradeModal = () => {
  const { paywall, minimumPlan, planLimit, closePaywall } = usePaywallHost();
  if (!paywall) return null;
  if (paywall === 'plans' && !minimumPlan) return <BillingModalHost onClose={closePaywall} />;
  return (
    <FeaturePlanChoiceModal
      paywall={paywall}
      minimumPlan={minimumPlan}
      planLimit={planLimit}
      onClose={closePaywall}
    />
  );
};
